import { useWindowSizeStore } from "@/shared/stores";

export default {
	created() {
		useWindowSizeStore().init();
	},
	computed: {
		windowWidth() {
			return useWindowSizeStore().width;
		},
	},
};
